import { render, staticRenderFns } from "./SortIcon.vue?vue&type=template&id=c0c75b9c&scoped=true"
import script from "./SortIcon.vue?vue&type=script&lang=ts"
export * from "./SortIcon.vue?vue&type=script&lang=ts"
import style0 from "./SortIcon.vue?vue&type=style&index=0&id=c0c75b9c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c75b9c",
  null
  
)

export default component.exports